export const MESSAGE = {
  NO_DATA: 'Không có dữ liệu.',
  ERROR_SYSTEM: 'Có lỗi trong quá trình tải dữ liệu.',
  RESTORE_SUCCESS: 'Khôi phục dữ liệu thành công',
  RESTORE_FAILED: 'Khôi phục dữ liệu thất bại',
  UPLOAD_SUCCESSFUL: 'Tải file thành công',
  UPDATE_SUCCESS: 'Cập nhật thành công',
  UPDATE_FAILED: 'Cập nhật không thành công',
  SAVE_SUCCEED: 'Lưu thành công.',
  ADD_SUCCEED: 'Thêm mới thành công.',
  SAVE_FAILED: 'Lưu không thành công.',
  SEND_SUCCEED: 'Gửi thành công.',
  SEND_FAILED: 'Gửi không thành công.',
  DELETE_SUCCEED: 'Xóa thành công.',
  DELETE_FAILED: 'Xóa không thành công.',
  REQUIRED_FIELD: 'Trường này không được bỏ trống.',
  INVALID_FILE:
    'Hệ thống hỗ trợ định dạng file {TYPE}, dung lượng <= {SIZE}MB. Ví dụ: Hệ thống hỗ trợ định dạng file .PDF, .DOC, .DOCX, .XLSX, .XLS, .JPEG, .JPG, .PNG, .PPT, .PPTX, dung lượng <= 20MB.',
  ACTION_CONFIRM: 'Xác nhận thực hiện thao tác này?',
  INVALID_CODE: 'Chỉ bao gồm chữ cái không dấu, dấu _ và không chứa khoảng trắng.',
  INVALID_PASSWORD:
    'Mật khẩu phải có từ 8-50 ký tự. Dùng ít nhất một chữ số, một chữ hoa, một chữ thường, một ký tự đặc biệt và không chứa khoảng trắng',
  INVALID_CONFIRM_PASSWORD: 'Hai mật khẩu không giống nhau.',
  INVALID_EMAIL: 'Email không hợp lệ',
  INVALID_NATURAL_NUMBER: 'Trường này chỉ cho phép số tự nhiên.',
  INVALID_DECIMAL_NUMBER: 'Vui lòng nhập một số thập phân hợp lệ.',
  MAX_50: 'Trường này không được vượt quá 50 ký tự.',
  MAX_15: 'Trường này không được vượt quá 15 ký tự.',
  MAX_5: 'Trường này không được vượt quá 5 ký tự.',
  MAX_255: 'Trường này không được vượt quá 255 ký tự.',
  MAX_500: 'Trường này không được vượt quá 500 ký tự.',
  MAX_100: 'Trường này không được vượt quá 100 ký tự.',
  MAX_1000: 'Trường này không được vượt quá 1000 ký tự.',
  MAX_2000: 'Trường này không được vượt quá 2000 ký tự.',
  MAX_5000: 'Trường này không được vượt quá 5000 ký tự.',
  MAX_6000: 'Trường này không được vượt quá 6000 ký tự.',
  MAX_60000: 'Trường này không được vượt quá 60000 ký tự.',
  UPLOAD_FILE: 'Vui lòng chọn file có định dạng .doc, .docx, .pdf, .xls, .xlsx, .jpg, .png',
  MAX_DATA_UPLOAD: 'Vui lòng chọn file có dung lượng < 50MB',
  MAX_7_BACKUP: 'Tối thiểu 7 bản sao lưu',
  MAX_31_DAYS: 'Tối đa 31 ngày',
  DOC_EXISTS: 'File này đã tồn tại'
}
